import { createContext, useContext, useState } from "react";

import axios from "axios";

const IndexSnapshotContext = createContext();

export const IndexSnapshotProvider = ({ children }) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [indexDetail, setIndexDetail] = useState(null);
  const [indexDetailLoading, setIndexDetailLoading] = useState(false);
  const [indexDetailError, setIndexDetailError] = useState(null);
  const [indexTabs, setIndexTabs] = useState(null);
  const [indexTabLoading, setIndexTabLoading] = useState(false);
  const [indexTabError, setIndexTabError] = useState(null);

  const getIndexSnapshot = async (indexName) => {
    try {
      setIndexDetail(null);
      setIndexDetailError(null);
      setIndexDetailLoading(true);
      //   resetIndexSnapshot();
      const res = await axios.get(`${BASE_URL}/api/indexData/${indexName}`);
      setIndexDetail(res?.data?.data);
    } catch (err) {
      setIndexDetailError(err.message);
      setIndexDetailLoading(false);
    } finally {
      setIndexDetailLoading(false);
    }
  };
  const resetIndexSnapshot = () => {
    setIndexDetail(null);
    setIndexDetailLoading(false);
    setIndexDetailError(null);
  };

  const getIndexTabs = async (symbol) => {
    try {
      setIndexDetailLoading(true);
      setIndexDetailError(null);
      const res = await axios.get(
        `${BASE_URL}/api/index-tabs?symbol=${symbol}`,
      );
      setIndexTabs(res.data);
    } catch (err) {
      setIndexTabError(err);
      setIndexTabLoading(false);
    } finally {
      setIndexTabLoading(false);
    }
  };

  return (
    <IndexSnapshotContext.Provider
      value={{
        indexDetail,
        indexDetailLoading,
        indexDetailError,
        getIndexSnapshot,
        resetIndexSnapshot,
        indexTabs,
        indexTabError,
        indexTabLoading,
        getIndexTabs,
      }}
    >
      {children}
    </IndexSnapshotContext.Provider>
  );
};

export const useIndexSnapshot = () => useContext(IndexSnapshotContext);
